import HistoryBehavioralDrawer from './history-behavioral-drawer';

export default HistoryBehavioralDrawer;
